// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { Navigate, useLocation } from 'react-router-dom';

export type AdminViewRedirectProps = Readonly<{
  /** Target path to redirect to */
  to: string;
}>;

/**
 * AdminViewRedirect Component
 *
 * A redirect component for old admin routes that redirects to the new unified
 * pages with the ?view=all query parameter to set the toggle to "All Advisors" view.
 *
 * Usage:
 * - /admin/relationships -> /relationships?view=all
 * - /admin/clients -> /clients?view=all
 * - /admin/policies -> /policies?view=all
 */
export function AdminViewRedirect({ to }: AdminViewRedirectProps) {
  const location = useLocation();
  const targetUrl = `${to}?view=all`;

  return <Navigate to={targetUrl} replace state={{ from: location }} />;
}

export default AdminViewRedirect;
